import Vue from "vue";

export const state = Vue.observable({
  showViewer: false
});

export const mutations = {
  setShowViewer: (value) => {
    state.showViewer = value
  }
}